import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-[#E5E0D8] text-center" data-id="element-25">
      <p className="text-[#736B65] text-sm" data-id="element-26">
        © {new Date().getFullYear()} El Ritual de 10 Minutos. Todos los
        derechos reservados.
      </p>
      <p className="text-[#A39C97] text-xs mt-2 max-w-xl mx-auto" data-id="element-27">
        Este producto no sustituye el consejo médico profesional, diagnóstico o
        tratamiento.
      </p>
    </footer>;
}